export default {
    data() {
        return {
            sizeOptions: [
                { text: '4"', value: '4'},
                { text: '5"', value: '5' },
                { text: '7"', value: '7' },
                { text: '10"', value: '10' },
                { text: '12"', value: '12' },
            ]
        }
    }
}